import type {SyllabusTermPlan} from "app/employee/state/syllabus/mutations";
import {IonBadge} from "@ionic/react";
import {useTranslation} from "react-i18next";

interface Props {
  plan: SyllabusTermPlan["clientPlan"];
}

const badgeColors: Record<SyllabusTermPlan["clientPlan"]["__typename"], string> = {
  ClientFullPlan: "induction-course",
  ClientRefreshPlan: "refresher-course"
};

export const PlanBadge = ({plan}: Props) => {
  const {t} = useTranslation();
  const planType = plan.__typename;
  return (
    <strong>
      {planType === "ClientFullPlan" && (
        <IonBadge color={badgeColors[planType]}>
          {t("syllabus.in-progress.induction-course", {defaultValue: "Встъпително"})}
        </IonBadge>
      )}
      {planType === "ClientRefreshPlan" && (
        <IonBadge color={badgeColors[planType]}>
          {t("syllabus.in-progress.refresh-course", {defaultValue: "Опреснително"})}
        </IonBadge>
      )}{" "}
    </strong>
  );
};
